import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as o, Flex as t } from "@chakra-ui/react";
import { SearchInput as l } from "../../../forms/SearchInput/SearchInput.mjs";
const x = ({
  children: a,
  onSearch: r
}) => {
  const s = o("Table");
  return /* @__PURE__ */ i(t, { sx: s.headerContent, children: [
    r ? /* @__PURE__ */ e(
      l,
      {
        size: "sm",
        width: { base: "100%", md: "300px" },
        name: "search",
        onSearch: r,
        "aria-label": "Table search"
      }
    ) : /* @__PURE__ */ e("div", {}),
    /* @__PURE__ */ e(t, { sx: s.headerActions, children: a })
  ] });
};
export {
  x as TableHeader
};
